import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import Vuetify from 'vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App'
import VueAnalytics from 'vue-analytics'
import Clipboard from 'v-clipboard'
import VueAdsense from './vendor-components/v-adsense/index'

import '../node_modules/vuetify/dist/vuetify.min.css'

Vue.use(Vuex)
Vue.use(Vuetify)
Vue.use(VueAxios, axios)
Vue.use(Clipboard)
Vue.use(VueAdsense)
Vue.config.productionTip = false

const api = '/resource/'

const store = new Vuex.Store({
  state: {
    icons: null,
    timestamp: null,
    date: null,
    meta: {},
    services: {
      'material.io': {
        cdn: 'https://fonts.googleapis.com/css?family=Material+Icons',
        git: 'https://github.com/google/material-design-icons',
        npm: 'https://www.npmjs.com/package/material-design-icons',
        cssPrefix: 'material-icons',
        url: 'https://material.io'
      },
      'materialdesignicons.com': {
        cdn: 'https://cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/2.0.46/css/materialdesignicons.min.css',
        git: 'https://github.com/Templarian/MaterialDesign-Webfont',
        npm: 'https://www.npmjs.com/package/mdi',
        cssPrefix: 'mdi',
        url: 'https://materialdesignicons.com'
      },
      'fontawesome.com': {
        cdn: 'https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css',
        git: 'https://github.com/FortAwesome/Font-Awesome',
        npm: 'https://www.npmjs.com/package/font-awesome',
        cssPrefix: 'fa',
        url: 'https://fontawesome.com'
      },
      'weathericons.io': {
        cdn: 'https://cdnjs.com/libraries/weather-icons',
        git: 'https://github.com/erikflowers/weather-icons',
        npm: 'https://www.npmjs.com/package/weather-icons',
        cssPrefix: 'wi',
        url: 'http://weathericons.io'
      },
      'ionicons.com': {
        cdn: 'http://code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css',
        git: 'https://github.com/ionic-team/ionicons',
        npm: 'https://www.npmjs.com/package/ionicons',
        cssPrefix: 'ion',
        url: 'http://ionicons.com/'
      },
      'emoji-css': {
        cdn: 'https://afeld.github.io/emoji-css/emoji.css',
        git: 'https://github.com/afeld/emoji-css/',
        npm: null,
        cssPrefix: 'em',
        url: 'https://afeld.github.io/emoji-css/'
      },
      'govicons.io': {
        cdn: null,
        git: 'https://github.com/540co/govicons',
        npm: 'https://www.npmjs.com/package/govicons',
        cssPrefix: 'gi',
        url: 'http://govicons.io/'
      }
    },
    googleAnalyticsId: 'UA-17572030-22',
    googleAdSenseAdClient: 'ca-pub-4259822914193810',
    consentCookieName: '_iconsio_cookie_policy_',
    primaryColor: 'deep-orange darken-2',
    secondaryColor: 'grey darken-2',
    headline: [
      'headline',
      'grey--text',
      'text--darken-1',
      'pb-3'
    ],
    title: [
      'title',
      'grey--text',
      'text--darken-1',
      'pb-3'
    ],
    caption: [
      'caption',
      'grey--text',
      'text--darken-1',
      'py-3'
    ],
    iconsPreviewLength: 16,
    // apiEndpoint: 'http://localhost:8888/material-design-icons/resource'
    apiEndpoint: location.href.includes('local') ? `http://icons.wemakesites.local${api}` : api
  },
  mutations: {
    icons (state, icons) {
      state.icons = icons
    },
    timestamp (state, timestamp) {
      state.timestamp = timestamp
    },
    date (state, date) {
      state.date = date
    },
    meta (state, data) {
      state.meta = data
    }
  },
  getters: {
    timestamp: state => {
      return state.timestamp
    },
    date: state => {
      return state.date
    },
    icons: state => {
      return state.icons
    },
    googleAnalyticsId: state => {
      return state.googleAnalyticsId
    },
    apiEndpoint: state => {
      return state.apiEndpoint
    }
  }
})

/* eslint-disable no-new */
new Vue({
  router,
  store,
  components: { App },
  template: '<App/>',
  created () {
    const store = this.$store
    this.$http(store.getters.apiEndpoint).then(response => {
      response = response.data
      store.commit('icons', response.icons)
      store.commit('timestamp', response.timestamp)
      store.commit('date', response.date)
      this.$http('/static/data/meta.json').then(response => {
        store.commit('meta', response.data)
        this.$mount('#app')
      })
    })
  }
})

Vue.use(VueAnalytics, {
  id: store.getters.googleAnalyticsId,
  router
})



// WEBPACK FOOTER //
// ./src/main.js